const auth = JSON.parse(localStorage.getItem('auth') || '{}');

export const getAuthFromLocalStorage = () => auth;
